import { useState } from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik'

import { FormValues } from '..'
import { Address } from '@models/address'
import { AddressDialog } from './AddressDialog'
import { AddressSearch } from '@components/AddressSearch'
import { InvalidMessage } from '@components/UI/Form/InvalidMessage'
import { TextArea } from '@components/UI/Form/TextArea'

export function PropertyAddress() {
  const [showAddressDialog, setShowAddressDialog] = useState(false)
  const {
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldError,
    setFieldValue
  } = useFormikContext<FormValues>()

  function handleAddressSelect(address: Address) {
    setFieldError('property.address', undefined)
    setFieldValue('property.address', address)
  }

  function clearAddress() {
    setFieldValue('property.address', null)
  }

  return (
    <div className="bg-white p-8 rounded shadow-sm" id="property">
      <AddressDialog
        isOpen={showAddressDialog}
        onConfirm={handleAddressSelect}
        handleClose={() => setShowAddressDialog(false)}
      />
      <h2 className="text-2xl font-black tracking-tight mb-8">
        Specify Property Address
      </h2>
      <p className="mb-4">
        Enter the property address from the inspection below.
      </p>
      <AddressSearch
        address={values.property.address ?? undefined}
        onSelect={handleAddressSelect}
        onSelectMissing={() => setShowAddressDialog(true)}
        clearAddress={clearAddress}
        suggestMissing
        setTouched={() => setFieldTouched('property.address', true)}
        isErrored={Boolean(
          errors.property?.address && touched.property?.address
        )}
      />
      <ErrorMessage name="property.address" component={InvalidMessage} />
      <h3 className="text-xl font-bold tracking-tight mt-8 mb-2">
        Is there anything else we should know about the property?
      </h3>
      <p className="mb-4">
        For example, you want to make sure we address the tree in the front
        yard.
      </p>
      <Field
        component={TextArea}
        placeholder="Property comments..."
        name="property.comments"
      />
    </div>
  )
}
